import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Edit24 } from "@carbon/icons-react";
import {
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  OverflowMenu,
  OverflowMenuItem,
} from "carbon-components-react";

import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { toast } from "react-toastify";
const tableHeaders = [
  {
    header: "Seguradora",
    key: "insurerName",
  },
  {
    header: "Tipo de seguro",
    key: "type",
  },
  {
    header: "Descricao",
    key: "description",
  },
  // {
  //   header: "Operacoes",
  //   key: "actions",
  // },
];

const LinkList = ({ url }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url} title="Editar">
        <Edit24 />
      </Link>
    </li>
  </ul>
);

const ListInsurance = ({ insurerId, insuranceId }) => {
  const [insurance, setInsurance] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(10);

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await http.get(`/listinsurance`);
      getInsuranceData(response);
      console.log("Filter", response);
    } catch (e) {
      toast.error(e);
    }
  };

  const getInsuranceData = (response) => {
    try {
      const data = response?.data?.map((ins) => ({
        id: ins.id,
        insurerName: ins.insurerName,
        type: ins.type,
        description: ins.description,
        actions: (
          <OverflowMenu flipped>
            <OverflowMenuItem
              key="optionOne"
              itemText="Editar"
              onClick={() =>
                navigate("../actualizar-seguro/" + ins.id, {
                  state: { insuranceId: ins.id, insurerId: insurerId },
                })
              }
            />
          </OverflowMenu>
        ),
      }));
      setInsurance(data);
      setCount(response.data.totalElements);
    } catch (e) {
      toast.error(e);
    }
  };
  const onPageChange = async ({ page, pageSize }) => {
    try {
      const pag = page - 1;
      console.log("pag", pag, "Pagesize", pageSize);

      const response = await http.get(`listinsurance`);
      getInsuranceData(response);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card title="Todos seguros">
      <DataTable
        rows={insurance}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar"></TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default ListInsurance;
